import { Controller } from "@hotwired/stimulus"

// Auto-saves the employer email-notification toggles. Debounced PATCH to the
// form's action with the CSRF token; updates the status target. Ported from the
// legacy inline <script> in employer_dashboard/settings.html.erb.
export default class extends Controller {
  static targets = ["form", "status"]

  save() {
    clearTimeout(this.timer)
    if (this.hasStatusTarget) this.statusTarget.textContent = "Saving…"
    this.timer = setTimeout(() => this.submit(), 150)
  }

  submit() {
    const form = this.hasFormTarget ? this.formTarget : this.element.querySelector("form")
    if (!form) return
    const token = document.querySelector('meta[name="csrf-token"]')
    fetch(form.action, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": token ? token.getAttribute("content") : "",
        Accept: "application/json",
      },
      body: new FormData(form),
      credentials: "same-origin",
    })
      .then((r) => this.flash(r.ok ? "Saved" : "Couldn't save"))
      .catch(() => this.flash("Connection error"))
  }

  flash(msg) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = msg
    if (msg === "Saved") {
      setTimeout(() => {
        if (this.hasStatusTarget) this.statusTarget.textContent = ""
      }, 1500)
    }
  }
}
